import { render, staticRenderFns } from "./TitleBySideItem.vue?vue&type=template&id=1b6a4c76&scoped=true"
import script from "./TitleBySideItem.vue?vue&type=script&lang=js"
export * from "./TitleBySideItem.vue?vue&type=script&lang=js"
import style0 from "./TitleBySideItem.vue?vue&type=style&index=0&id=1b6a4c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a4c76",
  null
  
)

export default component.exports